var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationalresource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_109_9478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_109_9478",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_9478",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_9478",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABv0lEQVR4nO3cQUoDQRSE4caFoifQiUdUl8Z7iOCJ1J3eRCUizKokZBaBoOBkul5ez/9dIN2V15N0EVIKAAAAALRI7fqS9CLpRtJJdM4tB73tTdIlQfvCjptszcs1QXs8E7THiqBNCNqEoE0I2oSgTQjaxHExOZP0IOlDM1YMQT9Gb/IQ1A75SNJ39CYPQdage0m3krqqG9jsoZO0HF5ztKyPjmX1he/uYx32aI4Fnkq6l/Q+Xc6qPsm/TPZo7vVuL/xiOP5jjmQXsN6cQe95JJcB67zLHvSYSemHN4gPw38EvdAMlGj7HsksIgOe5PtpFo5A6TqU98KSTu2Q6TqSB93TdeyGTdchuo72r+B0HWZ0HSZ0HSZ0HSZ0HZXRdUyMrmPDETRdh/JewdMh6BaCHqaaR4fydh3pVA+60u860gkLeqqfWmVxCEGfawZKNLoOE7qOyug6JkbXseEImguLuILb1J5mSiVH0EPYPDpE19HORP8x6XQdTnQdJnQdJnQdJnQdldF1mGhmShTNTCFoD4I2IWgTgjYhaI9Pgvbgb41Nrpjo+l4lHRN0/ZAXJZLatZL0tH5chE4yAAAAABSDH4B0vL3F1NEgAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationalresource);
export default __webpack_public_path__ + "static/media/Educational resource.d8f06219cabf163bb9ded89d74eb2a15.svg";
export { ForwardRef as ReactComponent };